<template>
  <v-card class="pa-0 text-center" rounded="md" outlined>
    <v-card-title v-if="account.logo" :style="`border-top: 3px solid ${colorBackground ? colorBackground : account.color_background}`">
      <v-row justify="center">
        <v-sheet class="overflow-hidden" width="90" rounded="lg" outlined>
          <v-responsive class="align-center" :aspect-ratio="1/1">
            <v-sheet class="px-1" color="white" width="90">
              <v-img :src="account.logo.split(/[?#]/)[0]" width="100%" />
            </v-sheet>
          </v-responsive>
        </v-sheet>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      <v-row>
        <v-col class="pb-0 text-center" cols="12">
          <span class="d-block subtitle-1 font-weight-medium mt-1">{{instance.document.name}} Nº {{instance.number}} de {{account.name}}</span>
          <span class="d-block body-2 text--primary font-weight-regular">para {{instance.customer.name}}</span>
          <span class="d-block body-1 font-weight-medium mt-5">{{instance.total | currency(instance.currency)}} {{instance.currency}} del {{instance.date | date}}</span>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-divider />
    <v-card-text class="py-2 background">
      <v-list class="transparent">
        <v-list-item class="px-1 my-1">
          <v-list-item-title class="text--secondary font-weight-medium text-left">Dirección del envío</v-list-item-title>
          <v-list-item-subtitle v-if="instance.address" class="text-left">{{instance.address}}</v-list-item-subtitle>
          <v-list-item-subtitle v-else class="text-left">No especificado</v-list-item-subtitle>
        </v-list-item>
        <v-list-item class="px-1 my-1">
          <v-list-item-title class="text--secondary font-weight-medium text-left">Tipo de despacho</v-list-item-title>
          <v-list-item-subtitle class="text-left">{{instance.shipping_type}}</v-list-item-subtitle>
        </v-list-item>
        <v-list-item class="px-1 my-1">
          <v-list-item-title class="text--secondary font-weight-medium text-left">Nombre del conductor</v-list-item-title>
          <v-list-item-subtitle v-if="instance.carrier_name">{{instance.carrier_name}}</v-list-item-subtitle>
          <v-list-item-subtitle v-else class="text-left">No especificado</v-list-item-subtitle>
        </v-list-item>
        <v-list-item class="px-1 my-1">
          <v-list-item-title class="text--secondary font-weight-medium text-left">ID del conductor</v-list-item-title>
          <v-list-item-subtitle v-if="instance.carrier_id">{{instance.carrier_id}}</v-list-item-subtitle>
          <v-list-item-subtitle v-else class="text-left">No especificado</v-list-item-subtitle>
        </v-list-item>
        <v-list-item class="px-1 my-1">
          <v-list-item-title class="text--secondary font-weight-medium text-left">Patente del transporte</v-list-item-title>
          <v-list-item-subtitle v-if="instance.licence_plate">{{instance.licence_plate}}</v-list-item-subtitle>
          <v-list-item-subtitle v-else class="text-left">No especificado</v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-divider />
    <v-card-text class="py-0 background">
      <v-row>
        <v-col class="pa-0 pb-2" cols="12">
          <v-textarea class="elevation-0" v-model="messageBody" @input="updateMessage($event)" :placeholder="placeholder" auto-grow background-color="background" solo flat hide-details />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import ReminderViewMixin from '@/mixins/ReminderViewMixin'
export default {
  mixins: [
    ReminderViewMixin
  ]
}
</script>